import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAlertIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "alert_icon",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3759_23153",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 25,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				y: .423096,
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_3759_23153)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "alert_icon_2",
				d: "M12 16.0384C12.2288 16.0384 12.4207 15.9611 12.5755 15.8064C12.7303 15.6516 12.8077 15.4598 12.8077 15.2309C12.8077 15.0021 12.7303 14.8103 12.5755 14.6554C12.4207 14.5006 12.2288 14.4232 12 14.4232C11.7712 14.4232 11.5793 14.5006 11.4245 14.6554C11.2697 14.8103 11.1923 15.0021 11.1923 15.2309C11.1923 15.4598 11.2697 15.6516 11.4245 15.8064C11.5793 15.9611 11.7712 16.0384 12 16.0384ZM11.25 12.6347H12.75V7.80792H11.25V12.6347ZM12 21.9039C9.83717 21.3141 8.0465 20.041 6.628 18.0847C5.20933 16.1283 4.5 13.9412 4.5 11.5232V5.76942L12 2.96167L19.5 5.76942V11.5232C19.5 13.9412 18.7907 16.1283 17.372 18.0847C15.9535 20.041 14.1628 21.3141 12 21.9039ZM12 20.3232C13.7333 19.7732 15.1667 18.6732 16.3 17.0232C17.4333 15.3732 18 13.5398 18 11.5232V6.79817L12 4.55767L6 6.79817V11.5232C6 13.5398 6.56667 15.3732 7.7 17.0232C8.83333 18.6732 10.2667 19.7732 12 20.3232Z",
				fill: "#BE4E01"
			})
		})]
	})
});
export default SvgAlertIcon;
